import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import Styles from "./SkuStyles.module.scss"
import AddToCart from "./AddToCart"

const Sku = ({ id, images, name, price, sizes }) => {
  return (
    <div key={id} className={Styles.sku}>
      <Link className={Styles.productlink} to={`/product/${id}`}>
        <Img
          className={Styles.image}
          fluid={images[0].fluid}
          alt={images[0].description}
        />
      </Link>
      <p className={Styles.name}>{name}</p>
      <p className={Styles.price}>£{price}</p>
      <AddToCart
        id={id}
        name={name}
        image={images[0]}
        price={price}
        sizes={sizes}
      />
    </div>
  )
}

// Sku.propTypes = {
//     id: PropTypes.string,
//     name: PropTypes.string,
//     price: PropTypes.string,
//   }

Sku.defaultProps = {
  id: `1234567`,
  name: `name`,
  price: `£00.00`,
}

export default Sku
